import React, {useEffect, useState} from 'react';
import {Button, Col, Input, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import {Space, Table, Tag} from 'antd';
import ProPortalHeader from "../componets/ProPortalHeader";
import './style.scss'
import {DashboardIcon, AccountIcon, ArtIcon, LibIcon} from './imgs/Icons'
import {get_screens_info} from "./server";
import Navigator from "../componets/Navigator";

const columns = [
    {
        title: 'Device Name',
        dataIndex: 'name',
        key: 'name',
        render: (text) => <a>{text}</a>,
    },
    {
        title: 'Serial No.',
        dataIndex: 'sn',
        key: 'sn',
    },
    {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        // render: (_, {status}) => (
        //     <>
        //         {status.map((tag) => {
        //             let color = tag === 'offline' ? 'geekblue' : 'green';
        //             return (
        //                 <Tag color={color} key={tag}>
        //                     {tag.toUpperCase()}
        //                 </Tag>
        //             );
        //         })}
        //     </>
        // ),
    },
    {
        title: 'Group',
        dataIndex: 'group',
        key: 'group',
    },
    {
        title: 'Playlist name',
        dataIndex: 'playlist',
        key: 'playlist',
    },
    {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
    },
    {
        title: 'Operation',
        key: 'operation',
        render: (_, record) => (
            <Space size="middle">
                <a>Detail</a>
                <a>Delete</a>
            </Space>
        ),
    },
];

const DashBoard = (props) => {
    const [data, setData] = useState([])
    useEffect(() => {
        get_screens_info().then(res => {
            setData(res.data)
        })
    }, [])
    return (
        <Layout>
            <Content>
                <ProPortalHeader/>
                <Row style={{margin: '8rem 0 0 0'}}>
                    <Col lg={4} style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: 'column'
                    }}>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="106" height="106" viewBox="0 0 106 106"
                                 fill="none">
                                <circle cx="52.9434" cy="53.041" r="52.1035" fill="#D9D9D9"/>
                            </svg>
                        </div>
                        <p className={'bp-ds-profile-txt'}>
                            Jing Dong
                        </p>
                        <p className={'bp-ds-profile-txt'}>
                            jing.dong@vieunite.com
                        </p>
                        <p className={'bp-ds-profile-txt'}>
                            Premium Subscription
                        </p>
                    </Col>
                    <Col lg={4}>
                        <div className={'bp-ds-status-div'}>
                            <div className={'bp-ds-status-1'}>
                                <div className={'bp-ds-status-sm'}>
                                    <p className={'bp-ds-status-title'}>
                                        Screens
                                    </p>
                                    <p className={'bp-ds-status-txt'}>
                                        Number of screens in subscription
                                    </p>
                                </div>
                                <div className={'bp-ds-status-sm'}>
                                    <p className={'bp-ds-status-title'}>
                                        Online
                                    </p>
                                    <p className={'bp-ds-status-txt'}>
                                        Number of screens currently online
                                    </p>
                                </div>
                            </div>
                            <div className={'bp-ds-status-2'}>
                                <div className={'nb'}>
                                    3
                                </div>
                                <div className={'vertical-line'}>

                                </div>
                                <div className={'nb'}>
                                    1
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row justify={"center"}>
                    <Navigator/>
                    <Col lg={20} style={{
                        background: '#F4F4F4',
                    }}>
                        <div className={'bp-ds-ctrl-div'}
                             style={{width: '40%', margin: '4rem 0 0 2rem'}}>
                            <Input className={'bp-ds-input'}
                                   placeholder={'Search by name or serial number'}
                            />
                            <Button className={'bp-search-btn'}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"
                                     fill="none">
                                    <path
                                        d="M12.9531 24.125C18.8557 24.125 23.6406 19.34 23.6406 13.4375C23.6406 7.53496 18.8557 2.75 12.9531 2.75C7.05058 2.75 2.26562 7.53496 2.26562 13.4375C2.26562 19.34 7.05058 24.125 12.9531 24.125Z"
                                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M24.7656 25.25L22.5156 23" stroke="white" stroke-width="2"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </Button>
                            <Button className={'bp-ds-ctrl-btn'}>Group</Button>
                            <Button className={'bp-ds-ctrl-btn'}>Status</Button>
                        </div>

                        <div className={'bp-ds-ctrl-div'}>
                            <Button className={'bp-ds-ctrl-btn'}>Publish</Button>
                            <Button className={'bp-ds-ctrl-btn'}>Schedule</Button>
                            <Button className={'bp-ds-ctrl-btn'}>Setting</Button>
                            <Button className={'bp-ds-ctrl-btn'}>Control</Button>
                        </div>

                        <Table style={{
                            margin: '8rem 2rem 0 2rem',
                            borderRadius: '8px',
                            border: '2px solid #FFF'
                        }} columns={columns} dataSource={data}/>
                    </Col>
                </Row>


            </Content>
        </Layout>
    )
}

export default DashBoard;
